import { createFileRoute, redirect } from '@tanstack/react-router';
import { homePathForSession } from '@/lib/auth-guards';
import { authClient } from '@/lib/auth-client';

/**
 * The app has no public landing page. Signed-in people go to their home; everyone else goes to
 * sign-in. (The marketing site, if any, lives elsewhere.)
 */
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession();
    // TanStack Router redirects are thrown objects by design, not Error instances.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: session ? await homePathForSession() : '/sign-in' });
  },
  component: () => null,
});
